<template>
  <div class="inputBox" v-if="state" :class="state?'inputBoxShow':''">
    <div class="inputBoxCont">
      <div class="title">
        {{title}}
      </div>
      <div class="inputBoxContent">
        <slot name="content"></slot>
      </div>
      <div class="inputBoxBottom clear">
        <button class="but affirmBut" @click="butFn('affirm')" :class="{'affirmButAc':affState, 'disabled': disabled}" :disabled="disabled"  >确认</button>
        <span class="but cancelBut" @click="butFn('cancel')">取消</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'xk-inputBox',
    props: {
      title: {
        default () {
          return ''
        }
      },
      closeState: {
        default () {
          return ''
        }
      },
      disabled: {
        default () {
          return false
        }
      }
    },
    data () {
      return {
        state: false,
        affState: true
      }
    },
    methods: {
      butFn: function (state) {
        let that = this
        switch (state) {
          case 'affirm':
            if (that.affState) {
              that.$emit('click', state)
              if (!that.$props.closeState) {
                that.state = false
              }
            }
            break
          case 'cancel':
            that.state = false
            that.$emit('click', state)
            break
        }
      },
      stateFn: function () {
        this.state = !this.state
      },
      affStateFn: function (state) {
        if (state) {
          this.affState = true
        } else {
          this.affState = false
        }
      }
    },
    mounted: function () {
      let that = this
      that.state = true
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .inputBox {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: -100;
    background-color: rgba(0, 0, 0, 0.5);
    .inputBoxCont {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) scale(0, 0);
      opacity: 0;
      min-width: 70%;
      max-width: 80%;
      background-color: #fff;
      border-radius: 0.333rem;
      transition: 0.3s all;
      .title {
        font-size: 1.5rem;
        line-height: 2.5rem;
        margin-top: 1rem;
        color: #333;
        text-align: center;
      }
      .inputBoxContent {
        padding: 1rem;
      }
      .inputBoxBottom {
        text-align: center;
        .but {
          float: left;
          display: inline-block;
          width: 50%;
          background-color: #eeeeee;
          color: #bbbbbb;
          line-height: 3.5rem;
          font-size: 1.25rem;
        }
        .affirmBut {
          border-radius: 0 0 0 0.333rem;
          border: none;
        }
        .cancelBut {
          background-color: #eeeeee;
          color: #bbbbbb;
          border-radius: 0 0 0.333rem 0;
        }
        .affirmButAc {
          background-color: #f06550;
          color: #fff;
        }
        .disabled {
          background-color: #999999;
        }
      }
    }
    .othersPhoneInput {
      width: 100%;
      border: none;
      border-bottom: 1px solid #eee;
      font-size: 1.25rem;
      line-height: 2.5rem;
      text-align: center;
      margin-bottom: 1rem;
    }
  }

  .inputBoxShow {
    z-index: 555;
    .inputBoxCont {
      opacity: 1;
      transform: translate(-50%, -50%) scale(1, 1);
    }
  }
</style>



// WEBPACK FOOTER //
// inputBox.vue?46a488f9